import { Users, Music4, CircleDollarSign, Globe2 } from "lucide-react";
import { StatCounter } from "./StatCounter";
import { useLanguage } from "@/context/LanguageContext";

const ICONS = { artists: Users, tracks: Music4, paidout: CircleDollarSign, countries: Globe2 };
const ACCENTS = { artists: "text-brand-red border-brand-red/20 bg-brand-red/[0.06]", tracks: "text-brand-blue border-brand-blue/20 bg-brand-blue/[0.06]", paidout: "text-brand-red border-brand-red/20 bg-brand-red/[0.06]", countries: "text-brand-blue border-brand-blue/20 bg-brand-blue/[0.06]" };

export const CommunityStats = () => {
  const { t } = useLanguage();
  const items = t.communityStats.items;

  return (
    <section data-testid="community-stats-section" className="relative border-y border-white/10 bg-white/[0.02] py-10 md:py-12 overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-y-8 sm:divide-x sm:divide-white/[0.08]">
          {items.map((stat, i) => {
            const Icon = ICONS[stat.id];
            return (
              <div key={stat.id} data-testid={`community-stat-${stat.id}`} className="flex items-center gap-3.5 sm:px-6 lg:px-8">
                <div className={`w-11 h-11 rounded-xl border flex items-center justify-center shrink-0 ${ACCENTS[stat.id]}`}>
                  <Icon className="w-5 h-5" />
                </div>
                <StatCounter id={stat.id} to={stat.to} prefix={stat.prefix} suffix={stat.suffix} label={stat.label} delay={i * 0.08} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
